import { render, staticRenderFns } from "./sweetStakeWayin.vue?vue&type=template&id=b3ce4b40&scoped=true&"
import script from "./sweetStakeWayin.vue?vue&type=script&lang=js&"
export * from "./sweetStakeWayin.vue?vue&type=script&lang=js&"
import style0 from "./sweetStakeWayin.vue?vue&type=style&index=0&id=b3ce4b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce4b40",
  null
  
)

export default component.exports